
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.688 8.748c-.161-.1-1.423-.856-1.924-1.086l-.621-1.5c.184-.495.537-1.886.592-2.127a.667.667 0 00-.178-.62l-.972-.972a.667.667 0 00-.62-.178c-.182.042-1.61.4-2.128.592l-1.5-.621c-.219-.48-.952-1.711-1.085-1.924A.667.667 0 0010.687 0H9.313a.667.667 0 00-.565.312c-.1.161-.856 1.423-1.086 1.924l-1.5.621c-.495-.185-1.886-.537-2.127-.592a.667.667 0 00-.62.178l-.972.972a.667.667 0 00-.178.62c.042.182.4 1.61.592 2.128l-.621 1.5c-.48.219-1.711.952-1.924 1.085A.667.667 0 000 9.313v1.374c0 .23.118.443.312.565.161.1 1.423.856 1.924 1.085l.621 1.5c-.185.496-.537 1.887-.592 2.128a.667.667 0 00.178.62l.972.972c.162.162.396.23.62.178.182-.042 1.61-.4 2.128-.592l1.5.621c.219.48.952 1.711 1.085 1.924a.667.667 0 00.565.312h1.374c.23 0 .443-.118.565-.312.1-.161.856-1.423 1.085-1.924l1.5-.621c.496.184 1.887.537 2.128.592a.666.666 0 00.62-.178l.972-.972a.667.667 0 00.178-.62c-.042-.182-.4-1.61-.592-2.128l.621-1.5c.48-.219 1.711-.952 1.924-1.085a.667.667 0 00.312-.565V9.313a.667.667 0 00-.312-.565zM10 14.36A4.365 4.365 0 015.64 10 4.364 4.364 0 0110 5.64 4.365 4.365 0 0114.36 10 4.364 4.364 0 0110 14.36z"}})])
          )
        }
      }
    